import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion/dist/framer-motion';

interface ISlideUpAnimationProps {
  children: React.ReactNode;
  trigger: boolean;
}

const SlideUpAnimation: React.FC<ISlideUpAnimationProps> = ({
  children,
  trigger,
}) => {
  const controls = useAnimation();

  useEffect(() => {
    controls.start({
      y: trigger ? 0 : '100%', //We start from "beneath" the page on open, or at 100% full height on close to run the animation
      opacity: 1,
      transition: { duration: 0.25 },
    });
  }, [trigger]);

  return (
    <div>
      <motion.div
        initial={{ y: '100%', opacity: 1 }}
        animate={controls}
        className="fixed bottom-0 left-0 right-0"
      >
        {children}
      </motion.div>
    </div>
  );
};

export default SlideUpAnimation;
